import axios from "axios";

const configuredBackend = process.env.REACT_APP_BACKEND_URL || "";
// On the live custom domain, always use the same-origin /api proxy. Cross-site
// auth cookies from the Emergent backend can be dropped by browsers on reload.
const isLiveCustomDomain = typeof window !== "undefined"
  && /(^|\.)mychoicetrading\.com$/i.test(window.location.hostname);
const BACKEND_URL = isLiveCustomDomain ? window.location.origin : configuredBackend;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let refreshPromise = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error?.config;
    const status = error?.response?.status;
    const url = String(request?.url || "");
    if (status !== 401 || request?._retried || url.includes("/auth/login")
        || url.includes("/auth/google/session") || url.includes("/auth/refresh")) {
      return Promise.reject(error);
    }
    request._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true })
          .finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      return api(request);
    } catch {
      return Promise.reject(error);
    }
  },
);

export default api;
